import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmMembershipComponent } from './confirm-membership/confirm-membership.component';
import { ConfirmDeleteApplicantComponent } from './confirm-delete-applicant/confirm-delete-applicant.component';
import { ConfirmDeleteBeneficiaryComponent } from './confirm-delete/confirm-delete-beneficiary.component';
import { ConfirmLeaveComponent } from './confirm-leave/confirm-leave.component';
import { PageSharedModule } from '@workflow/dynamic-render/page/shared/page-shared.module';
import { DynamicRenderSharedModule } from '@workflow/dynamic-render/shared/shared.module';
import { DynamicPipeModule } from '@workflow/pipe/dynamic-pipe.module';

const components = [ConfirmMembershipComponent, ConfirmDeleteApplicantComponent, ConfirmDeleteBeneficiaryComponent, ConfirmLeaveComponent];

@NgModule({
  declarations: [...components],
  exports: [...components],
  imports: [CommonModule, PageSharedModule, DynamicPipeModule, DynamicRenderSharedModule],
  providers: []
})
export class OaoCustomPopupModule {}
